import {computed, inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Role} from '../enum/role';
import {CurrentUserService} from './current-user';

@Injectable({providedIn: 'root'})
export class DashboardViewService {
  private readonly router = inject(Router);
  private readonly currentUser = inject(CurrentUserService);

  private readonly viewSignal = computed<'personal' | 'team' | null>(() => {
    const navigation = this.router.currentNavigation() ?? this.router.lastSuccessfulNavigation();
    const requestedView = (navigation?.extras.info as {dashboardView?: unknown} | undefined)?.dashboardView;

    const canViewPersonal = this.currentUser.hasAnyRole([Role.EMPLOYEE, Role.TRAINEE]);

    if (requestedView === 'personal' && canViewPersonal) return 'personal';
    if (this.currentUser.hasAnyRole([Role.MANAGER, Role.COACH])) return 'team';
    return canViewPersonal ? 'personal' : null;
  });

  get view(): 'personal' | 'team' | null {
    return this.viewSignal();
  }
}
